var Controller = require("common/Controller");
var Utils = require("common/Utils");

function AbstractSettingsDelegate() {
    Controller.call(this);

    /**
     * @abstract
     * @returns {string} - Internationalized label
     */
    this.getLabel = function() {
        throw new Error("Not implemented: getLabel()");
    };

    /**
     * @abstract
     * @param entry {object} An html element
     */
    this.setMenuEntry = function(entry) {
        throw new Error("Not implemented: setMenuEntry()");
    };

    /**
     * @abstract
     * @returns {*[]} - An array of views that appear as immediate children of the settings menu
     */
    this.getTopLevelViews = function() {
        throw new Error("Not implemented: getTopLevelViews()");
    };
}

Utils.inherits(AbstractSettingsDelegate, Controller);

module.exports = AbstractSettingsDelegate;